/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="15.73"
        height="14.12"
        viewBox="0 0 15.73 14.12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M7.06 14.12a7 7 0 0 0 5.38-2.48l-.76-.65a6.06 6.06 0 1 1 1.39-4.71l-1.51-1.06-.58.82 2.79 2 2-2.8-.82-.57-.89 1.27a7.06 7.06 0 1 0-7 8.22Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleArrow360DegreesIcon';

export default Icon;
